import { X_PROFILE_URL } from '@/config/social'

// The "Break Our Escrow" bounty on Testnet (docs/plans/testnet-carryover.md).
// The homepage banner announces it and hides itself once the bounty is over.

/** Midnight after Friday 13 November, Amsterdam time. */
export const BOUNTY_ENDS_AT = new Date('2026-11-14T00:00:00+01:00')

/** Where "Join the bounty" leads. The announcement lives on X until the
 *  written rules have a page of their own; swap the link here when they do. */
export const BOUNTY_URL = X_PROFILE_URL

export function isBountyLive(now = new Date()): boolean {
  return now < BOUNTY_ENDS_AT
}
